import React from "react";
import { withStyles } from "@material-ui/styles";

import Camera, { FACING_MODES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

import FlipCameraIosIcon from "@material-ui/icons/FlipCameraIos";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "./CloseIcon";

import images from "../../assets/img/images";

const styles = {
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: "12px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialog: {
    minWidth: "fit-content",
    maxHeight: "calc(100vh - 60px)",
  },
  switchCamera: {
    position: "absolute",
    bottom: "50px",
    left: "10%",
    cursor: "pointer",
  },
};

const TakePicture = (props) => {
  const { classes, setPicture } = props;
  const [open, setOpen] = React.useState(false);
  const [facingMode, setFacingMode] = React.useState(FACING_MODES.ENVIRONMENT);

  function handleTakePhoto(dataUri) {
    setPicture(dataUri);
    setOpen(false);
  }

  return (
    <>
      <Box
        style={{ cursor: "pointer", height: "22px" }}
        onClick={() => setOpen(true)}
      >
        <img src={images.cameraIconColored} alt="camera" />
      </Box>
      <Dialog
        open={open}
        classes={{ root: classes.dialogRoot, paper: classes.dialog }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ paddingTop: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className={classes.dialogTitle}>
                {/* {I18n.get("site_createProfile")} */}
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            style={{
              maxHeight: "calc(100vh - 120px)",
              overflow: "auto",
              padding: "24px",
              position: "relative",
            }}
          >
            <Camera
              onTakePhoto={(dataUri) => {
                handleTakePhoto(dataUri);
              }}
              idealFacingMode={facingMode}
            />
            <div
              className={classes.switchCamera}
              onClick={() =>
                setFacingMode(
                  facingMode === FACING_MODES.ENVIRONMENT
                    ? FACING_MODES.USER
                    : FACING_MODES.ENVIRONMENT
                )
              }
            >
              <FlipCameraIosIcon style={{ color: "white", fontSize: "45px" }} />
            </div>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(TakePicture);
